import { ChangeDetectorRef, Component, ElementRef, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy, inject, input, viewChild } from "@angular/core";

import { ComposantesScrollingCategoryComponent } from "../ComposantesScrollingCategory/ComposantesScrollingCategory.component";
import { QdmService, RankItem, ServiceItem } from "app/Services/qdm.service";
import { CourseCardComponent } from "../CourseCard/CourseCard.component";
import { Subscription, combineLatest } from "rxjs";
import { CartItem, CartService, CartStructure } from "app/Cart/CartService";
import { CartDisplayComponent } from "../CartDisplay/CartDisplay.component";
import { EnterpriseResponse, FullAdmissionsData } from "app/Services/gestion.service";
import { MealKitIconButtonComponent } from "@yoni/mealcomponents-lib";
import { ResponsiveService } from "app/Services/responsive.service";
import { OrderByPipe } from "app/Pipes/OrderBy.pipe";
import { AuthService } from "app/Services/auth.service";
import { QuantitySelectorComponent } from "../QuantitySelector/QuantitySelector.component";
import { GestionService } from "app/Services/gestion.service";

@Component({
    imports: [
    ComposantesScrollingCategoryComponent,
    CourseCardComponent,
    CartDisplayComponent,
    MealKitIconButtonComponent,
    OrderByPipe,
    QuantitySelectorComponent
],
    selector: "day-menu-display",
    template: `
    <div class="w-full h-full flex py-2 pt-0 md:pt-4 gap-2">
      @if (this.selectedService) {
        <div #scrollableContent (scroll)="onScroll($event)"
          class="w-full overflow-y-scroll pb-24">
          <composantes-scrolling-category (scrollToComponentRequested)="scrollToComponent($event)"
            [service]="this.selectedService"/>
            @if (this.selectedAdmission && this.filteredAdmissions().length > 1) {
              <mk-icon-button (click)="this.resetAdmission()"
                [label]="'Changer de menu (' + this.selectedAdmission.admissionName + ')'"
                class="h-12 changeMenu my-4 w-fit mx-auto"
                icon="menu_book"
                useSvg="false"/>
            }
            @if (this.enterpriseData && this.enterpriseData.canOrderMultiple) {
              <div
                class="py-4 w-fit mx-auto bg-white rounded border p-2 border-gris-3 mt-2 block md:hidden">
                <p class="text-sm w-full text-center font-semibold fg-noir-2">Commande de groupe
                (max. {{ this.enterpriseData.maxOrderNumber }})</p>
                <qty-selector (quantityChange)="this.groupOrderQuantityChanged($event)"
                  [max]="this.enterpriseData.maxOrderNumber" [min]="1"
                  [value]="this.groupOrderQuantity"
                  class="w-32 h-8 mx-auto block "/>
                </div>
              }
              @if (this.periodicities() && !this.isPeriodicity(this.date)) {
                <div
                  class="my-4 w-full py-4 rounded bg-noir-2 px-4 text-white font-semibold flex items-center">
                  <div class="flex items-center gap-2 h-full">
                    <span class="material-icons">
                      visibility
                    </span>
                  </div>
                  <p class="text-sm w-full">Vous êtes en mode <b>visualisation</b>, vous ne pouvez pas commander pour cette
                date.</p>
              </div>
            }
            @for (component of getFilteredComponents(this.selectedService)|orderBy: 'rank'; track component) {
              <div class="mb-6 mt-2">
                <h2 [attr.data-component-id]="component.id" class="text-lg font-bold text-noir-1 mb-3">{{ component.name }}
                  @if (!this.selectedAdmission?.isFullMenu) {
                    @if (this.selectedAdmission && this.admissionQuantities[component.family_id || component.id] && !this.admissionExtraRanksIds.includes(component.family_id || component.id)) {
                      <span
                        >
                        ({{ this.admissionQuantities[component.family_id || component.id].needed }} {{ this.admissionQuantities[component.family_id || component.id].mandatory ? 'obligatoire(s)' : 'facultatif(s)' }}
                        ):
                        <span
                          [style.color]="this.admissionQuantities[component.family_id || component.id].mandatory ? 'red' : '#8abd27'">
                          {{ this.admissionQuantities[component.family_id || component.id].remaining }} restant(s)
                        </span>
                      </span>
                    }
                    @if (this.selectedAdmission && this.admissionQuantities[component.family_id || component.id] && this.admissionExtraRanksIds.includes(component.family_id || component.id)) {
                      <span
                        class="fg-noir-2 text-sm">
                        (en extra)
                      </span>
                    }
                  }
                </h2>
                <div
                  class="p-2 grid grid-cols-[repeat(auto-fill,minmax(250px,max-content))] gap-2 relative auto-rows-fr justify-center md:justify-start">
                  @for (course of component.courses; track course) {
                    <course-card
                      [boldCourses]="this.boldCourses()" [childId]="this.childId"
                      [courseItem]="course" [currentService]="selectedService" [date]="this.date"
                      [dyslexie]="this.dyslexie()" [iconsServices]="this.iconsServices"
                      [isExtra]="this.admissionExtraRanksIds.includes(component.family_id || component.id)"
                      [markedAllergens]="this.markedAllergens()"
                      [mode]="this.mode()" [rankItem]="component" [uppercaseCourses]="this.uppercaseCourses()"
                      class="mx-auto h-full flex"/>
                  }
                  @if (this.selectedAdmission &&
                    !this.admissionExtraRanksIds.includes(component.family_id || component.id) &&
                    (this.admissionQuantities[component.family_id || component.id]?.remaining === 0 ||
                    this.lockAllBecauseTotalQtyMet) || this.selectedAdmission?.isFullMenu) {
                    <div
                    class="absolute left-0 top-0 right-0 bottom-0 bg-black/50 cursor-not-allowed"></div>
                  }
                </div>
              </div>
            }
          </div>
        }
    
        @if (this.selectedService) {
          <cart-display
            [iconsServices]="this.iconsServices"
            class="fadeIn bg-white hidden md:block md:w-96 border border-gris-3 bg-white h-full"/>
        }
        @if (this.selectedService) {
          <div (click)="this.clickedOnMobileCart($event)"
            [class.hidden]="!this.isMobileCartShowed"
            class="bg-black/80 fixed p-8 top-[4.99rem] bottom-[4.99rem] md:hidden z-50 left-0 right-0">
            <div class="w-full h-full bg-white">
              <cart-display [iconsServices]="this.iconsServices" class="bg-white w-full h-full"/>
            </div>
          </div>
        }
      </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: [
        `
    .fadeIn {
      animation: fadeIn 0.5s forwards;
    }

    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    `
    ]
})
export class DayMenuDisplayComponent implements OnInit, OnDestroy, OnChanges {
 private qdm = inject(QdmService);
 private auth = inject(AuthService);
 private cdr = inject(ChangeDetectorRef);
 private cart = inject(CartService);
 private responsive = inject(ResponsiveService);
 private gestion = inject(GestionService);


 readonly scrollableContent = viewChild<ElementRef>('scrollableContent');

  private sub: Subscription = new Subscription();

  public readonly mode = input.required<"day" | "week">();

  readonly uppercaseCourses = input<boolean>(false);

  readonly boldCourses = input<boolean>(false);

  readonly dyslexie = input<boolean>(false);

  readonly hiddenServices = input<number[]>([]);

  readonly markedAllergens = input<number[]>([]);

  readonly periodicities = input<string[]>();


  readonly admissions = input<FullAdmissionsData[]>([]);

  protected selectedService: ServiceItem | undefined = undefined;
  childId: number = -1;
  date!: Date;
  groupOrderQuantity: number = 1;
  selectedAdmission: FullAdmissionsData | null = null;
  lockAllBecauseTotalQtyMet: boolean = false;

  isMobileCartShowed: boolean = false;

  // Ajout de la propriété pour stocker les icônes
  iconsServices: { [key: number]: { url: string; bg: string } } = {};

  /** Données mises à jour selon l'admission */
  protected admissionQuantities: { [key: number]: { needed: number, remaining: number, used: number, mandatory: boolean } } = {};
  protected admissionServicesIds: number[] = [];
  protected admissionExtraRanksIds: number[] = [];
  /** END */

  cartItems: CartItem[] = [];
  fullCart: CartStructure[] = [];
  isInitialized: boolean = false;
  enterpriseData: EnterpriseResponse | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['date']) {
      this.refreshAdmissionQuantities();
    }

  }


  ngOnInit(): void {
    this.sub.add(this.responsive.isMobileCartShowed$.subscribe(isMobileCartShowed => {
      this.isMobileCartShowed = isMobileCartShowed;
      this.cdr.detectChanges();
    }));

    this.sub.add(this.qdm.currentService$.subscribe((service) => {
      this.selectedService = service;
      this.cdr.detectChanges();
      this.updateCartItems();

      // Ajout de l'appel au fetch des icônes
      if (service) {
        const idsNotNull = service.components.map((c) => c.family_id || c.id);
        this.gestion.fetchServicesIcones(idsNotNull).then((icones) => {
          this.iconsServices = icones;
          this.cdr.detectChanges();
        });
      }
    }));

    this.sub.add(this.qdm.selectChild$.subscribe((child) => {
      this.childId = child?.id || -1;
      this.cdr.detectChanges();
      this.updateCartItems();
    }));

    this.sub.add(this.qdm.selectedDate$.subscribe((date) => {
      if (date) {
        this.date = date;

        this.cdr.detectChanges();
        this.updateCartItems();
      }
    }));

    this.sub.add(this.qdm.groupOrderQuantity$.subscribe((groupOrderQuantity) => {
      this.groupOrderQuantity = groupOrderQuantity;
      this.cdr.detectChanges();
      this.refreshAdmissionQuantities();
    }));

    this.sub.add(this.qdm.selectedAdmission$.subscribe((admission) => {
      this.selectedAdmission = admission;
      this.cdr.detectChanges();
      this.refreshAdmissionQuantities();
    }));

    this.sub.add(this.cart.cart$.subscribe((cart) => {
      this.fullCart = cart;
      this.updateCartItems();
    }));

    this.sub.add(this.auth.userEnterprise$.subscribe((enterprise) => {
      this.enterpriseData = enterprise;
      this.cdr.detectChanges();
    }));

    // Utiliser combineLatest pour s'assurer que toutes les données sont chargées
    this.sub.add(
      combineLatest([
        this.qdm.currentService$,
        this.qdm.selectChild$,
        this.qdm.selectedDate$,
        this.cart.cart$
      ]).subscribe(([service, child, date, cart]) => {
        if (service && date) {
          this.isInitialized = true;
          this.refreshAdmissionQuantities();
        }
      })
    );
  }

  filteredAdmissions(): FullAdmissionsData[] {
    return this.admissions().filter(admission => admission.mealMoment.qdm_id === this.selectedService?.mealtime_id);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  updateCartItems(): void {
    if (!this.selectedService || !this.date) {
      return;
    }

    try {
      const dateFormatted = this.date.formatDate('forApi');
      this.cartItems = this.fullCart.find(cart =>
        cart.serviceId === this.selectedService?.id &&
        cart.childId === this.childId &&
        cart.date === dateFormatted
      )?.items || [];

      this.cdr.detectChanges();
      this.refreshAdmissionQuantities();
    } catch (error) {
      console.error("Error updating cart items:", error);
    }
  }

  onComponentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const componentElement = target.closest('[data-component-id]');
    if (componentElement) {
      const componentId = componentElement.getAttribute('data-component-id');
      // TODO scroll to component
    }
  }

  refreshAdmissionQuantities(): void {
    if (!this.selectedAdmission || !this.date || !this.selectedService) {
      this.admissionQuantities = {};
      this.admissionServicesIds = [];
      this.admissionExtraRanksIds = [];
      this.lockAllBecauseTotalQtyMet = false;
      return;
    }

    this.admissionServicesIds = this.selectedAdmission.admissionParts.map(part => part.serviceId);

    // Réinitialiser les quantités
    this.admissionQuantities = {};

    const restaurant = this.qdm.selectedRestaurantSubject.value;
    let totalQty = 0;
    // Pour chaque partie d'admission
    this.selectedAdmission.admissionParts.forEach(part => {

      const componentId = part.serviceId;
      const neededQuantity = part.quantity * this.groupOrderQuantity;

      // Calculer combien d'items de ce composant sont déjà dans le panier
      let usedQuantity = this._getTotalInCartForComponentFamily(componentId);

      if(part.isLegume && this.selectedService && restaurant){
        // on est sur le légume, on doit récupérer le nombre de plats complets viandes et légumes
        const fullMeatQty = this.cart.getFullMeatCoursesCount(this.selectedService.id, restaurant.id, this.childId, this.date);
        const fullVeganQty = this.cart.getFullVeganCoursesCount(this.selectedService.id, restaurant.id, this.childId, this.date);


        usedQuantity += fullMeatQty + fullVeganQty;
      }

      totalQty += usedQuantity;
      // Calculer combien il reste de slots disponibles
      const remaining = Math.max(0, neededQuantity - usedQuantity);

      this.admissionServicesIds.push(componentId);

      this.admissionQuantities[componentId] = {
        needed: neededQuantity,
        remaining: remaining,
        used: usedQuantity,
        mandatory: part.isMandatory == 1
      };

      if (part.serviceIsNotInAdmission) {
        this.admissionExtraRanksIds.push(componentId);
      }
    });

    this.lockAllBecauseTotalQtyMet = totalQty >= this.selectedAdmission.admissionMax * this.groupOrderQuantity;

    // Forcer la détection de changements
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 0);
  }

  _getTotalInCartForComponentFamily(componentId: number): number {
    if (!this.selectedService || !this.cartItems || this.cartItems.length === 0) {
      return 0;
    }

    // Trouver tous les composants qui ont le même family_id ou id que componentId
    const relatedComponentIds = this.selectedService.components
      .filter(component =>
        (component.family_id && component.family_id === componentId) ||
        (component.id === componentId)
      )
      .map(component => component.id);

    // Ajouter le componentId lui-même à la liste
    if (!relatedComponentIds.includes(componentId)) {
      relatedComponentIds.push(componentId);
    }

    // Calculer la somme des quantités pour tous les items du panier correspondant à ces composants
    const total = this.cartItems
      .filter(item => relatedComponentIds.includes(item.rankId) && !this.admissionExtraRanksIds.includes(item.rankId))
      .reduce((acc, item) => acc + item.quantity, 0);

    return total;
  }

  getFilteredComponents(service: ServiceItem): any {
    if (!this.selectedAdmission || this.selectedAdmission.isFullMenu) {
      return service.components || [];
    }

    return service.components.filter(component => this.admissionServicesIds.includes(component.family_id || component.id));
  }

  scrollToComponent($event: RankItem) {
    const scrollableContent = this.scrollableContent();
    if (!scrollableContent) {
      return;
    }

    const element = scrollableContent.nativeElement;
    const componentElement = element.querySelector(`[data-component-id="${$event.id}"]`);

    if (componentElement) {
      scrollableContent.nativeElement.scrollTo({
        top: componentElement.offsetTop - 300,
        behavior: 'smooth'
      });
    }
  }

  onScroll($event: Event) {
    // highlight the component that is currently in the viewport
    const scrollableContent = this.scrollableContent();
    if (!scrollableContent) return;

    // get all components html elements
    const components = scrollableContent.nativeElement.querySelectorAll('[data-component-id]');
    if (!components.length) return;

    // Get the scrollable container's dimensions
    const containerTop = scrollableContent.nativeElement.scrollTop;
    const containerHeight = scrollableContent.nativeElement.clientHeight;
    const containerBottom = containerTop + containerHeight;

    // Threshold value (percentage of container height)
    const thresholdPercentage = 0.01; // 25% threshold
    const threshold = containerHeight * thresholdPercentage;

    // Keep track of the component with the most visibility
    let maxVisibleComponent: Element | null = null;
    let maxVisibleArea = 0;

    // Check each component to see which one is most visible in the viewport
    components.forEach((component: Element) => {
      const rect = component.getBoundingClientRect();
      const scrollRect = this.scrollableContent()?.nativeElement.getBoundingClientRect();

      if (!scrollRect) return;

      // Convert component position to be relative to the scrollable container
      const componentTop = rect.top - scrollRect.top + containerTop;
      const componentBottom = componentTop + rect.height;

      // Calculate how much of the component is visible
      const visibleTop = Math.max(componentTop, containerTop + threshold);
      const visibleBottom = Math.min(componentBottom, containerBottom - threshold);
      const visibleArea = Math.max(0, visibleBottom - visibleTop);

      // Adjust visibility calculation for mobile
      // Only consider a component if it's significantly visible
      if (visibleArea > rect.height * 0.4) { // Component must be at least 40% visible
        // Update if this component has more visible area than previous max
        if (visibleArea > maxVisibleArea) {
          maxVisibleArea = visibleArea;
          maxVisibleComponent = component;
        }
      }
    });

    // Add highlighting class to the most visible component and remove from others
    if (maxVisibleComponent) {
      const componentId = (maxVisibleComponent as Element).getAttribute('data-component-id');

      // Supprimer la classe highlighted de tous les composants
      document.querySelectorAll('[data-scrollable-component-id]').forEach((component: Element) => {
        (component as Element).classList.remove('highlighted-component');
      });

      // Trouver et surligner le composant correspondant
      const highlightedComponent = document.querySelector(`[data-scrollable-component-id="${componentId}"]`);
      highlightedComponent?.classList.add('highlighted-component');

      // Faire défiler le composant surligné en vue si trouvé
      if (highlightedComponent) {
        // Trouver le conteneur de défilement (parent avec overflow-x-auto)
        const scrollContainer = highlightedComponent.closest('.overflow-x-auto');

        if (scrollContainer) {
          // Calculer la position pour centrer l'élément dans la vue
          const containerWidth = scrollContainer.clientWidth;
          const componentLeftPosition = (highlightedComponent as HTMLElement).offsetLeft;
          const componentWidth = highlightedComponent.clientWidth;

          // Scrollez pour que l'élément soit au centre ou simplement visible
          scrollContainer.scrollTo({
            left: componentLeftPosition - (containerWidth / 2) + (componentWidth / 2),
            behavior: 'smooth'
          });
        }
      }
    }
  }

  resetAdmission() {
    this.qdm.selectedAdmissionSubject.next(null);
    this.cdr.detectChanges();
  }

  clickedOnMobileCart($event: MouseEvent) {
    if ($event.target === $event.currentTarget) {
      this.isMobileCartShowed = false;
      this.cdr.detectChanges();
    }
  }

  isPeriodicity(arg0: Date|undefined) {

    if(!arg0)return false;
    const periodicities = this.periodicities();
    if(!periodicities)return false;

    return periodicities.some(p => p === arg0.formatDate('forApi'));
  }


  groupOrderQuantityChanged($event: number) {
    this.groupOrderQuantity = $event;
    this.qdm.groupOrderQuantitySubject.next(this.groupOrderQuantity);
    this.cdr.detectChanges();
  }
}
